import { Button, ButtonGroup } from 'rsuite';
import { icons } from '@shared/static/icons';

function RenderButton({ option, value, setValue }) {
  return (
    <Button
      active={option.value === value}
      onClick={() => setValue(option.value)}
      type="button"
    >
      {option.icon &&
        (typeof option.icon === 'string' ? icons[option.icon] : option.icon)}
      <p>{option.label}</p>
    </Button>
  );
}

export default function TabsComponent({
  setValue,
  options,
  value,
  fullWidth = false,
  isGroup = false,
}) {
  const Wrapper = isGroup ? ButtonGroup : 'div';

  return (
    <Wrapper
      className={`tabsComponent ${isGroup ? 'tabsComponent-group' : ''} ${fullWidth ? 'full-width' : ''} ${options.length === 1 ? 'single-option' : ''}`}
    >
      {options.map((option) => (
        <RenderButton
          key={option.value}
          option={option}
          value={value}
          setValue={setValue}
        />
      ))}
    </Wrapper>
  );
}
